<template>
  <div>
    <b-container fluid class="px-5">
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow title="Ajouter un transit"/>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b-form @submit.stop.prevent="onSubmit">

          <b-form-group
            id="name-input"
            label="Nom *"
            label-for="name-input"
            class="bold-label"
            :invalid-feedback="form.name.invalidFeedback"
            :state="form.name.state"
          >
            <b-form-input
              id="name-input"
              v-model="form.name.value"
              type="text"
              maxlength="250"
              :state="form.name.state"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group
            class="bold-label"
            label="Description"
            label-for="description-input"
            :state="form.description.state"
            :invalid-feedback="form.description.invalidFeedback"
          >
            <b-form-textarea
              id="description-input"
              class="mt-1"
              maxlength="5000"
              v-model="form.description.value"
              :state="form.description.state"
            ></b-form-textarea>
          </b-form-group>

          <div class="d-flex justify-content-end">
            <b-button type="submit" variant="secondary" :disabled="sendButtonDisabled">Valider</b-button>
          </div>
        </b-form>

      </b-card>
    </b-container>
  </div>
</template>

<script>

import api from '../../services/api';
import BackArrow from "../../components/BackArrow";

export default {

  name: 'TransitCreate',

  components: {
    BackArrow
  },

  data() {
    return {
      sendButtonDisabled: false,
      form: {
        name: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        description: {
          state: null,
          invalidFeedback: null,
          value: null
        }
      }
    }
  },

  methods: {

    onSubmit() {
      this.sendButtonDisabled = true

      let data = new FormData()
      data.append('name', this.form.name.value)
      if (this.form.description.value && this.form.description.value.trim() !== "") {
        data.append('description',  this.form.description.value)
      }

      api({
        method: 'POST',
        url: 'transit',
        data: data
      })
        .then((response) => {
          this.$router.push({
            name: 'TransitIndex'
          }, () => {
            this.$nextTick(() => {
              this.successToast(this.form.name.value)
            })
          })
        })
        .catch((error) => {
          this.sendButtonDisabled = false
          if (error.response.status === 418) {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]["state"] = false
            this.form[invalidField]["invalidFeedback"] = error.response.data.message
          }
        });
    },

    successToast(transitName) {
      this.$bvToast.toast(`Transit \"${transitName}\" ajouté`, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/transit/TransitCreate.vue